import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  connect() {

  }

  expand(e) {

    if ( e.target.textContent === "Read Less") {
      e.target.textContent = "Read More"
    } else {
      e.target.textContent = "Read Less"
    }

    this.contentTarget.classList.toggle('expand')
  }
}
